import mockPurchase from './purchase';
import { initMock, passThroughOtherCalls } from './mock';

const mockApi = () => {
  initMock();
  mockPurchase();
  passThroughOtherCalls();
};

export default mockApi;



// WEBPACK FOOTER //
// ./app/services/mock/index.js